import basic from './common/basic.js';
import updater from '../updater.js';

/* State example:
state: {
  byId: {
    com1: {
      read: true
    }
  }
  selections: [],
  showResolved: false,
  allowNotifications: true,
}
*/

const options = {};

const state = {
  byId: {},
  open: null,
  selections: [],
  showResolved: false,
  allowNotifications: true,
};

const getters = {
  ...basic.getters(options),

  /**
   * Return the comment read state
   * @param   {string} id
   * @returns {boolean}
   */
  getRead(state) {
    return id => {
      return state.byId[id]?.read || false;
    };
  },

  /**
   * Return the thread read state
   * @param   {string} id
   * @returns {boolean}
   */
  // getThreadRead(state) {
  //   return id => {
  //     return (
  //       (state.byId[id].read &&
  //         state.byId[id].children.every(child => state.byId[child].read)) ||
  //       false
  //     );
  //   };
  // },

  /**
   * Return whether all comments are read
   * @returns {boolean}
   */
  getReadAll(state) {
    return Object.values(state.byId).every(node => node.read);
  },

  /**
   * Return the currently open comment
   * @return {string}   The id of the currently open comment
   */
  getOpen(state) {
    return state.open;
  },

  /**
   * Return whether we should show resolved comments
   * @returns {boolean}
   */
  getShowResolved(state) {
    return state.showResolved;
  },

  /**
   * Return whether we receive notifications
   * @returns {boolean}
   */
  getAllowNotifications(state) {
    return state.allowNotifications;
  },
};

const actions = {
  ...basic.actions({ type: 'comments' }),

  /**
   * Create a configuration for default comment.
   * @param   {string}  id                      The comment id
   * @param   {boolean} read                    Whether the comment is read
   * @param   {boolean} apply                   Whether to apply the patch after finishing
   */
  customCreate(context, { id, read, apply }) {
    context.dispatch('create', {
      node: {
        id,
        read,
      },
      apply: false,
    });
    updater.complete({ apply });
  },

  /**
   * Set the comments read state to true
   * @param   {string}  ids                     The comment ids
   * @param   {boolean} apply                   Whether to apply the patch after finishing
   */
  setRead(context, { ids, apply }) {
    const patch = [];
    ids.forEach(id => {
      patch.push({
        op: 'replace',
        path: `/config/comments/byId/${id}/read`,
        value: true,
      });
    });
    updater.add(patch);
    updater.complete({ apply });
  },

  /**
   * Set the current open comment
   * @param {string}  id            The open comment
   * @param {boolean} apply         Whether to apply the patch
   */
  setOpen(context, { id, apply }) {
    const patch = [
      {
        op: 'replace',
        path: `/config/comments/open`,
        value: id,
      },
    ];
    updater.add(patch);
    updater.complete({ apply });
  },

  /**
   * Set the configuration whether to show resolved comments
   * @param {boolean} value         Whether to show resolved comments
   * @param {boolean} apply         Whether to apply the patch
   */
  setShowResolved(context, { value, apply }) {
    const patch = [
      {
        op: 'replace',
        path: `/config/comments/showResolved`,
        value,
      },
    ];
    updater.add(patch);
    updater.complete({ apply });
  },

  /**
   * Set the configuration whether to allow notification e-mails
   * @param {boolean} value         Whether to allow notification e-mails
   * @param {boolean} apply         Whether to apply the patch
   */
  setAllowNotifications(context, { value, apply }) {
    const patch = [
      {
        op: 'replace',
        path: `/config/comments/allowNotifications`,
        value,
      },
    ];
    updater.add(patch);
    updater.complete({ apply });
  },
};

const module = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations: {},
};

export default module;
